import { render, staticRenderFns } from "./easytable.vue?vue&type=template&id=12fc53aa&"
import script from "./easytable.vue?vue&type=script&lang=js&"
export * from "./easytable.vue?vue&type=script&lang=js&"
import style0 from "./easytable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports